import {
  WEBSITE_CRM_DEMO_DOC_ARTIFACT_ID,
  WEBSITE_CRM_DEMO_HTML_ARTIFACT_ID,
} from './websiteCrmDemo.js'
import {
  buildWebsiteCrmDocArtifactPayload,
  buildWebsiteCrmHtmlArtifactPayload,
} from './websiteCrmDemoContent.js'

export function buildWebsiteCrmDocArtifact(artifactId, selection) {
  const id = artifactId || WEBSITE_CRM_DEMO_DOC_ARTIFACT_ID
  return {
    artifactId: id,
    kind: 'doc',
    fileName: selection?.fileName ?? 'NexusB2B — CRM Test Report.md',
    description: selection?.description ?? 'Markdown',
    payload: buildWebsiteCrmDocArtifactPayload(),
  }
}
